import * as React from "react";
import { Typography, withStyles, Button } from "@material-ui/core";
import { ProfileStore } from "modules/profile/ProfileStore";
import i18n from "i18n";
import { observer } from "mobx-react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DevelopmentAvatarByUid from "modules/development/components/layouts/DevelopmentAvatarByUid";
import { ProfileService } from "modules/profile/ProfileService";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { default as firebase } from "common/Firebase";

const styles = (theme) => ({
  root: {
    width: "100%",
  },

  table: {
    width: "950px!important",
    backgroundColor: "white",
    marginBottom: "5%",
  },
  companyTitle: {
    fontFamily: "Roboto",
    fontSize: "22px",
    letterSpacing: "1.2px",
    marginBottom: "3%",
  },
  gridContent: {
    marginTop: "65px",
    display: "grid",
    gridTemplateColumns: "90px 1fr",
    gridColumnGap: "45px",
    maxWidth: "1000px!important",
    margin: "0 auto",
  },
  message: {
    "& > :first-child > :first-child": {
      maxWidth: "calc(100% - 64px)",
    },
  },
  gridSearch: {
    display: "table",
    height: "100%",
    "& > :first-child": {
      display: "table-cell",
      height: "100%",
      verticalAlign: "middle",
    },
  },
  buttonActive: {
    backgroundColor: "#ABC200",
    color: "black",
    "&:hover": {
      backgroundColor: "#92A501",
    },
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  circularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btnAddContributors: {
    height: "50px",
  },
  btnInactive: {
    backgroundColor: "#d4d4d4",
    color: "#7c7c7c",
    width: "100%",
  },
  btnActive: {
    backgroundColor: "#ebf3a3",
    color: "#9da65a",
    width: "100%",
  },
});

type IProps = {
  classes: any;
  item: any;
};

@observer
class UserRow extends React.Component<IProps> {
  state = {
    companyName: ProfileStore.companyName != "" ? ProfileStore.companyName : "",
    isLoading: true,
    anchorEl: null,
    menuActivedEl: null,
    userAccessAdministratorEl: null,
    menuInactivatedEl: null,
    userAccessOperatorEl: null,
    open: false,
    currentUserUid: "",
  };

  handleClickOpenModal = () => {
    this.setState({ open: true });
  };

  handleCloseModal = () => {
    this.setState({ open: false });
  };

  handleOpenLayerAdd = () => {
    ProfileStore.layerAdd = true;
    this.setState({});
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleClickenuActivedEl = (event) => {
    this.setState({ menuActivedEl: event.currentTarget });
  };

  handleCloseMenuActivedEl = () => {
    this.setState({ menuActivedEl: null });
  };

  handleClickenuMenuInactivatedEl = (event) => {
    this.setState({ menuInactivatedEl: event.currentTarget });
  };

  handleCloseMenuInactivatedEl = () => {
    this.setState({ menuInactivatedEl: null });
  };

  handleClickOpenAdministratorEl = (event) => {
    this.setState({ userAccessAdministratorEl: event.currentTarget });
  };

  handleCloseAdministratorEl = () => {
    this.setState({ userAccessAdministratorEl: null });
  };

  handleClickOpenUserAccessOperatorEl = (event) => {
    this.setState({ userAccessOperatorEl: event.currentTarget });
  };

  handleCloseUserAccessOperatorEl = () => {
    this.setState({ userAccessOperatorEl: null });
  };

  deleteUserModal(item) {
    this.handleClickOpenModal();
  }

  refreshcomponent() {
    this.setState({ isLoading: true });

    setTimeout(() => {
      ProfileStore.currentTab = 4;
      ProfileStore.currentTab = 2;
    }, 2000);
  }

  async deleteUser(item: any) {
    this.setState({ isLoading: true });

    this.handleClose();

    const removeUser = firebase.functions().httpsCallable("removeUser");

    let companyUid = await ProfileService.getCompanyID();

    removeUser({
      id: item.id,
      uid: item.data.uid,
      email: item.data.email,
      companyUid: companyUid,
    });

    this.refreshcomponent();
  }

  async disableOrActiveUser(item: any) {
    this.handleClose();
    const disableOrActiveUser = firebase
      .functions()
      .httpsCallable("disableOrActiveUser");

    await disableOrActiveUser({
      id: item.id,
      uid: item.data.uid,
      email: item.data.email,
      isDisabled: item.data.disabled,
    });

    this.refreshcomponent();
  }

  async changeUserAccess(item: any) {
    this.handleClose();

    const changeUserAccess = firebase
      .functions()
      .httpsCallable("changeUserAccess");

    let companyUid = await ProfileService.getCompanyID();

    await changeUserAccess({
      companyUid: companyUid,
      uid: item.data.uid,
      access: item.data.access,
      email: item.data.email,
    });

    this.handleCloseMenuActivedEl();
    this.handleCloseMenuInactivatedEl();

    this.refreshcomponent();
  }

  render() {
    const { classes, item } = this.props,
      {
        userAccessOperatorEl,
        userAccessAdministratorEl,
        menuActivedEl,
        menuInactivatedEl,
      } = this.state;

    return (
      <>
        <TableRow>
          <TableCell align="right">
            <span>
              <DevelopmentAvatarByUid development={item.data.uid} />
            </span>
          </TableCell>
          <TableCell align="left">
            <Typography noWrap>{item.data.displayName}</Typography>
          </TableCell>
          <TableCell align="left">{item.data.email}</TableCell>
          {ProfileStore.isCurrentUserAdmin ? (
            <TableCell align="left">
              {item.data.access == 0 ? (
                <>
                  <Button
                    aria-owns={
                      userAccessAdministratorEl
                        ? `userAccessAdministratorEl`
                        : undefined
                    }
                    aria-haspopup="true"
                    onClick={this.handleClickOpenAdministratorEl}
                  >
                    {i18n.profile.contributors.administrator}
                  </Button>

                  <Menu
                    id={`userAccessAdministratorEl`}
                    anchorEl={userAccessAdministratorEl}
                    keepMounted
                    open={Boolean(userAccessAdministratorEl)}
                    onClose={this.handleCloseAdministratorEl}
                  >
                    <MenuItem onClick={(e) => this.changeUserAccess(item)}>
                      {i18n.profile.contributors.operator}
                    </MenuItem>
                  </Menu>
                </>
              ) : (
                <>
                  <Button
                    aria-owns={
                      userAccessOperatorEl
                        ? `menu-userAccessuserAccessOperatorEl`
                        : undefined
                    }
                    aria-haspopup="true"
                    onClick={this.handleClickOpenUserAccessOperatorEl}
                  >
                    {i18n.profile.contributors.operator}
                  </Button>
                  <Menu
                    id={`menu-userAccessuserAccessOperatorEl`}
                    anchorEl={userAccessOperatorEl}
                    open={Boolean(userAccessOperatorEl)}
                    onClose={this.handleCloseUserAccessOperatorEl}
                  >
                    <MenuItem onClick={(e) => this.changeUserAccess(item)}>
                      {" "}
                      {i18n.profile.contributors.administrator}
                    </MenuItem>
                  </Menu>
                </>
              )}
            </TableCell>
          ) : (
            <></>
          )}
          <TableCell align="left" className={classes.disabledTable}>
            {item.data.disabled === false ? (
              <div>
                <Button
                  aria-owns={menuActivedEl ? `menu-actived` : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClickenuActivedEl}
                  className={classes.btnActive}
                >
                  {i18n.profile.contributors.actived}
                </Button>
                {ProfileStore.isCurrentUserAdmin ? (
                  <Menu
                    id={`menu-actived`}
                    anchorEl={menuActivedEl}
                    open={Boolean(menuActivedEl)}
                    onClose={this.handleCloseMenuActivedEl}
                  >
                    <MenuItem onClick={(e) => this.disableOrActiveUser(item)}>
                      {i18n.profile.contributors.inactive}
                    </MenuItem>
                    <MenuItem onClick={(e) => this.deleteUserModal(item)}>
                      {i18n.profile.contributors.delete}
                    </MenuItem>
                  </Menu>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div>
                <Button
                  aria-owns={menuInactivatedEl ? `menu-inactivated` : undefined}
                  aria-haspopup="true"
                  onClick={this.handleClickenuMenuInactivatedEl}
                  className={classes.btnInactive}
                >
                  {i18n.profile.contributors.inactivated}
                </Button>
                {ProfileStore.isCurrentUserAdmin ? (
                  <Menu
                    id={`menu-inactivated`}
                    anchorEl={menuInactivatedEl}
                    open={Boolean(menuInactivatedEl)}
                    onClose={this.handleCloseMenuInactivatedEl}
                  >
                    <MenuItem onClick={(e) => this.disableOrActiveUser(item)}>
                      {i18n.profile.contributors.active}
                    </MenuItem>
                    <MenuItem onClick={(e) => this.deleteUserModal(item)}>
                      {i18n.profile.contributors.delete}
                    </MenuItem>
                  </Menu>
                ) : (
                  <></>
                )}
              </div>
            )}
          </TableCell>
          <Dialog
            open={this.state.open}
            onClose={this.handleCloseModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{i18n.deleteUser}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {i18n.warningDeleteUser}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseModal} color="primary">
                {i18n.cancel}
              </Button>
              <Button
                onClick={(e) => this.deleteUser(item)}
                color="primary"
                autoFocus
              >
                {i18n.confirm}
              </Button>
            </DialogActions>
          </Dialog>
        </TableRow>
      </>
    );
  }
}

export default withStyles(styles)(UserRow);



// WEBPACK FOOTER //
// ./src/modules/profile/components/layouts/UserRow.tsx